import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './transfer.less'
import { formatMoney } from 'client/griffin'
import MoneyTextBox from 'components/common/money_text_box'
import TransferReviewBox from '../transfer_review_box'

const i18n = getI18n('components/edit_glimpse/transfer')

class Transfer extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string.isRequired,
    campaignName: PropTypes.string.isRequired,
    moneyboxAmount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    fields: PropTypes.object.isRequired,
    anyInactiveFieldsTouchedWithError: PropTypes.bool,
    onTransferAll: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    shouldAutoFocus: PropTypes.bool,
    onTransfer: PropTypes.func.isRequired,
    countryCode: PropTypes.string.isRequired,
  }

  handleTransferAllClick = () => {
    this.props.onTransferAll(this.props.moneyboxAmount)
  }

  handleTransfer = fields => {
    this.props.onTransfer(fields.transferAmount)
  }

  render() {
    const {
      fields: { transferAmount },
      anyInactiveFieldsTouchedWithError,
    } = this.props

    return (
      <form onSubmit={this.props.handleSubmit(this.handleTransfer)}>
        <div styleName="title">{i18n('title')}</div>
        <div styleName="current-balance">
          {i18n('current_balance')}
          &nbsp;
          {formatMoney(this.props.currency, this.props.moneyboxAmount)}
        </div>
        <a
          data-pa-click="transferAll"
          href="javascript:;"
          styleName="transfer-all"
          onClick={this.handleTransferAllClick}
        >
          {i18n('transfer_all')}
        </a>
        <div styleName="amount-container">
          <MoneyTextBox
            autoFocus={this.props.shouldAutoFocus}
            title={i18n('amount_title')}
            disableCents={false}
            dataNemo="transfer-amount-input"
            {...transferAmount}
          />
        </div>

        <TransferReviewBox
          campaignId={this.props.campaignId}
          showAmount={false}
        />

        <button
          data-pa-click="next"
          data-nemo="transfer-submit-button"
          styleName="transfer-btn"
          className={`vx_btn vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
        >
          {i18n('transfer_money')}
        </button>
      </form>
    )
  }
}

export default cssModules(Transfer, styles)
